import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "@/auth/AuthProvider";

/**
 * Gates staff-only routes (the admin roster). Coaches (any verified @genieacademy.com
 * login) pass; students are redirected home. Write actions inside are further gated on
 * `isAdmin` by the page itself. See .okf/decisions/decouple-ide-identity.md.
 */
export function RequireStaff({ children }: { children: ReactNode }) {
  const { user, isStaff, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!isStaff) return <Navigate to="/" replace />;
  return <>{children}</>;
}
